<script>
  export let onChangeDictionary;
</script>

<style>
  div.logo {
    background-color: white;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80px;
    padding: 10px;
  }

  div.logo img {
    height: 100%;
  }

  img.flag {
    width: 40px;
    cursor: pointer;
    margin-right: 10px;
  }

  span.langText {
    display: none;
  }

  /* Mobile phones */

  @media only screen and (max-width: 768px) {
    div.logo img {
      max-height: 50px;
    }

    div#navbarResponsive {
      margin-top: 10px;
    }

    span.langText {
      display: unset;
      color: white;
    }
  }
</style>

<!-- Navigation -->
<nav class="navbar navbar-expand-lg navbar-dark bg-dark static-top">
  <div class="container">
    <div>
      <a
        class="navbar-brand"
        href="https://institucional.us.es/catedraavenzoar/"
        target="_blank">
        <div class="logo">
          <img src="/images/logos/avenzoar.jpg" alt="Logo Avenzoar" />
        </div>
      </a>
      <a
        class="navbar-brand"
        href="http://www.farmaceuticosdesevilla.es/"
        target="_blank">
        <div class="logo">
          <img src="/images/logos/ricofse.png" alt="Logo RICOFSE" />
        </div>
      </a>
    </div>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarResponsive"
      aria-controls="navbarResponsive"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon" />
    </button>
    <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item" on:click={() => onChangeDictionary('es')}>
          <img class="flag" src="/images/flags/spain.svg" alt="Flag Spain" />
          <span class="langText">Español</span>
        </li>
        <li class="nav-item" on:click={() => onChangeDictionary('en')}>
          <img
            class="flag"
            src="/images/flags/united-kingdom.svg"
            alt="Flag UK" />
          <span class="langText">English</span>
        </li>
        <li class="nav-item" on:click={() => onChangeDictionary('pt')}>
          <img
            class="flag"
            src="/images/flags/portugal.svg"
            alt="Flag Portugal" />
          <span class="langText">Português</span>
        </li>
        <li class="nav-item" on:click={() => onChangeDictionary('de')}>
          <img
            class="flag"
            src="/images/flags/germany.svg"
            alt="Flag Germany" />
          <span class="langText">Deutsch</span>
        </li>
        <li class="nav-item" on:click={() => onChangeDictionary('fr')}>
          <img class="flag" src="/images/flags/france.svg" alt="Flag France" />
          <span class="langText">Français</span>
        </li>
        <li class="nav-item" on:click={() => onChangeDictionary('it')}>
          <img class="flag" src="/images/flags/italy.svg" alt="Flag Italy" />
          <span class="langText">Italiano</span>
        </li>
      </ul>
    </div>
  </div>
</nav>
